import { gql } from "@apollo/client";

export const ORGANIZATION_PARAMETERS = gql`
  query OrganizationParameters($category: String) {
    organizationParameters(category: $category) {
      key
      category
      label
      vendor
      direction
      configKeys
      enabled
      presentConfigKeys
      missingConfigKeys
    }
  }
`;

const organizationParameters = { ORGANIZATION_PARAMETERS };

export default organizationParameters;
